// Mock data for testing the dashboard
export const mockUserData = {
  user_id: "user123",
  user_name: "John Doe"
};

export const mockServerData = [
  {
    server_id: "server1",
    server_name: "Production Server",
    ws_connection: {
      ip_address: "127.0.0.1",
      port: 8080
    }
  },
  {
    server_id: "server2",
    server_name: "Development Server",
    ws_connection: {
      ip_address: "localhost",
      port: 8081
    }
  },
  {
    server_id: "server3",
    server_name: "Testing Server",
    ws_connection: {
      ip_address: "18.204.173.142",
      port: 8080
    }
  }
];

// Helper function to simulate connection status changes
export const simulateConnectionStatus = (serverId, isConnected) => {
  // In a real implementation, this would interact with the Pulsar service
  console.log(`Server ${serverId} connection status changed to ${isConnected ? 'connected' : 'disconnected'}`);
  return isConnected;
};
